import { render, staticRenderFns } from "./DispatchSummarySignatories.vue?vue&type=template&id=c78cbad0&scoped=true"
import script from "./DispatchSummarySignatories.vue?vue&type=script&lang=js"
export * from "./DispatchSummarySignatories.vue?vue&type=script&lang=js"
import style0 from "./DispatchSummarySignatories.vue?vue&type=style&index=0&id=c78cbad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78cbad0",
  null
  
)

export default component.exports